module.exports = __webpack_public_path__ + "static/img/biobank-4.a9a32407cacc35a3543fc320f03ff5bd.png";